export default {
  autoUpdate: 'Aktualizovať automaticky',
  updateInterval: 'Interval aktualizcie',
  lastUpdate: 'Posledn aktualizcia',
  nextUpdate: 'Ďalšia aktualizácia za {0}',
};
